import channel9 from './channel9';
import dailymotion from './dailymotion';
import vimeo from './vimeo';
import youtube from './youtube';

export default {
  channel9,
  dailymotion,
  vimeo,
  youtube,
};
